import { Layers } from "lucide-react";
import { Section, SectionHeading, Card } from "./service-revops-ui";
import { SectionCta } from "./service-revops-section-cta";
import { gohighlevelConfig as defaultConfig } from "./service-platform-config";
import type { PlatformConfig } from "./service-platform-config";

export function ServiceIndustries({
  config = defaultConfig,
}: {
  config?: PlatformConfig;
} = {}) {
  const industries = config.industries;
  return (
    <Section>
      <SectionHeading
        eyebrow={config.industriesEyebrow}
        navy={config.industriesHeadlineNavy}
        blue={config.industriesHeadlineBlue}
        sub={config.industriesSub}
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {industries.map((ind, i) => (
          <Card key={i} radius={22}>
            <h3
              className="font-display font-bold mb-4"
              style={{
                fontSize: "18px",
                color: "#071E61",
                letterSpacing: "-0.02em",
              }}
            >
              {ind.name}
            </h3>
            <ul className="space-y-2.5">
              {ind.builds.map((b) => (
                <li key={b} className="flex items-start gap-2">
                  <Layers
                    className="w-4 h-4 mt-0.5 shrink-0"
                    style={{ color: "#0B7CF2" }}
                  />
                  <span
                    style={{
                      fontSize: "13.5px",
                      lineHeight: 1.5,
                      color: "#536B89",
                    }}
                  >
                    {b}
                  </span>
                </li>
              ))}
            </ul>
          </Card>
        ))}
      </div>
      <SectionCta
        copy={config.industriesCtaCopy}
        label={config.industriesCtaLabel}
      />
    </Section>
  );
}
